<template>
  <div>
    <file-table
      v-if="!disabled"
      class="mb-4"
      ref="fileTable"
      label="Caricare qui i file, trascinandoli nel campo sottostante o utilizzando l'apposito pulsante."
      :value="pendingFiles"
      :custom-columns="pendingFilesCustomColumns"
      :custom-actions="pendingFilesCustomActions"
      :validate-file="validatePendingFile"
      @input="pendingFiles = $event"
      @upload="upload($event)">
    </file-table>

    <b-modal
      ref="pendingFilesTagsModal"
      title="Associa tag"
      size="xl"
      dialog-class="h-100"
      ok-only
      hide-header-close
      scrollable
      @hidden="selectedPendingFileIndex = null">
      <template v-if="selectedPendingFileIndex != null">
        <tag-form-field
          :value="selectedPendingFileTags"
          :dropdown="false"
          :context="context"
          :context-id="contextId"
          multiple
          @input="pendingFilesTagsSelected"
        />
        <!--
        :parameters="{
          nwi: true,
          workgroupIds: [workgroupId]
        }"
        -->
      </template>
    </b-modal>

    <template v-if="files && files.length">
      <b-button
        variant="primary"
        size="sm"
        block
        class="mb-2"
        @click.prevent="$refs.filterTagsModal.show()">
        Filtra per tag
      </b-button>
      <b-button
        variant="outline-primary"
        size="sm"
        block
        class="mb-2"
        @click.prevent="exportFiles()">
        Esporta file
      </b-button>

      <b-modal
        ref="filterTagsModal"
        title="Filtra per tag"
        size="xl"
        dialog-class="h-100"
        ok-only
        hide-header-close
        scrollable>
        <boolean-form-field
          v-model="allTags"
          inline
          label="Visualizza solamente i file che soddisfano contemporaneamente tutti i seguenti tag (invece di almeno uno)."
        ></boolean-form-field>

        <tag-form-field
          v-model="selectedTags"
          multiple
          :dropdown="false"
          :context="context"
          :context-id="contextId">
        </tag-form-field>
        <!--
        :parameters="{
          nwi: true,
          workgroupIds: [workgroupId]
        }"
        -->
      </b-modal>
    </template>

    <template v-if="files && filteredFiles.length">
      <data-table
        :columns="columns"
        :value="filteredFiles"
      />

      <b-modal
        ref="tagsModal"
        title="Associa tag"
        size="xl"
        dialog-class="h-100"
        ok-only
        hide-header-close
        scrollable
        @hidden="selected = null">
        <template v-if="selected">
          <tag-form-field
            :value="selected.tags.map(x => x.tag)"
            :dropdown="false"
            :context="context"
            :context-id="contextId"
            multiple
            @input="tagsSelected"
          />
          <!--
          :parameters="{
            nwi: true,
            workgroupIds: [workgroupId]
          }"
          -->
        </template>
      </b-modal>
    </template>
  </div>
</template>
<script>
import http from 'core/http/HttpService';
import env from 'environment';
import MomentUtilsMixin from 'vue-core/mixins/MomentUtilsMixin';
import notifier from 'vue-core/services/NotificationService';
import { beep, error2text } from 'core/utils';
import { downloadBlob } from 'vue-core/utils';
import findIndex from 'lodash/findIndex';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { variantForWorkgroup, helpForWorkgroup } from 'app/utils';
import { cloneFile } from 'core/utils';

export default {
  mixins: [ MomentUtilsMixin ],

  props: {
    permissions: {
      type: Object,
      default: undefined,
    },

    context: {
      type: String,
      required: true
    },

    contextId: {
      type: [String, Number],
      required: true
    },

    workgroupId: {
      type: Number,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.validatePendingFile = (item) => {
      if (!this.permissions || this.permissions.viewFilesWithNoTags) {
        return undefined;
      }

      if (!item.tags || !item.tags.length) {
        return "Specificare almeno un tag";
      }
    };

    this.pendingFilesCustomColumns = [
      {
        //label: 'Tag',
        class: 'col-12',
        type: 'component',
        component: 'tag-list',
        props: (item) => ({
          value: (item.tags || []).map(t => this.mapTag(t)),
          deletable: true,
          //askBeforeRemoving: true
        }),
        events: (item, index) => ({
          input: (v) => {
            this.updatePendingFileTags(item, index, v);
          }
        })
      },
    ];

    this.pendingFilesCustomActions = (item, index) => [
      {
        icon: 'tags',
        //label: 'Tag',
        exec: () => this.addTagToPendingFile(item, index),
        //show: () => this.permissions.updateFiles,
        buttonClass: 'text-info',
      },
    ],

    this.columns = [
      {
        //label: 'Nome',
        class: 'col-12 font-weight-bold',
        type: 'actions',
        actions: (item, index) => [
          {
            label: item.name,
            //exec: () => this.removeFile(item.filename)
            buttonClass: 'text-primary font-weight-bold pl-0',
            size: 'normal',
            exec: () => this.download(item)
          },
        ]
      },
      {
        //label: 'Tag',
        class: 'col-12',
        type: 'component',
        component: 'tag-list',
        props: (item) => ({
          value: this.getTags(item),
          deletable: true,
          askBeforeRemoving: true
        }),
        events: (item, index) => ({
          input: (v) => {
            this.updateTags(item, v);
          }
        })
      },
      {
        //label: 'Dimensione',
        class: 'col-6',
        value: (item) => item.size,
        type: 'filesize'
      },
      {
        //label: 'Azioni',
        class: 'col-6 text-right',
        type: 'actions',
        actions: (item, index) => [
          {
            icon: 'times',
            //label: 'Elimina',
            exec: () => this.removeFile(item),
            show: () => this.permissions.deleteFiles,
            buttonClass: 'text-danger',
          },
          {
            icon: 'pencil',
            //label: 'Rinomina',
            exec: () => this.renameFile(item),
            show: () => this.permissions.renameFiles,
            buttonClass: 'text-warning',
          },
          {
            icon: 'tags',
            //label: 'Tag',
            exec: () => this.addTag(item, index),
            show: () => this.permissions.addFileTags || this.permissions.removeFileTags,
            buttonClass: 'text-info',
          },
        ]
      },
    ];
  },

  data() {
    return {
      pendingFiles: [],
      files: [],
      selected: null,
      selectedPendingFileIndex: null,
      //tags: [],
      //tagsLoading: false,
      selectedTags: [],
      allTags: false,
    };
  },

  computed: {
    selectedPendingFileTags() {
      if (this.selectedPendingFileIndex == null) {
        return [];
      }
      return this.pendingFiles[this.selectedPendingFileIndex].tags || [];
    },

    filteredFiles() {
      //console.log('selectedTags', this.selectedTags);
      //console.log('files', this.files);

      if (!this.files) {
        return this.files;
      }

      if (!this.selectedTags.length) {
        return this.files;
      }

      const tagIds = new Set(this.selectedTags.map(t => t.id));
      return this.files.filter(f => {
        const numberOfTags = f.tags
          .map(t => t.tag.id)
          .filter(id => tagIds.has(id))
          .length
        return this.allTags
          ? numberOfTags == tagIds.size
          : numberOfTags > 0;
      });
    }
  },

  mounted() {
    this.loadFiles();
    this.subscribe();
  },

  beforeDestroy() {
    this.unsubscribe();
  },

  methods: {
    loadFiles() {
      const success = ({ statusCode, data }) => {
        console.log('Files correctly loaded:', data);
        this.files = data;
      };

      const error = ({ statusCode, data }) => {
        console.log('Files loading error:', data);
        alert(error2text(data));
      };

      http.get({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files'
      }).then(success, error);
    },

    exportFiles() {
      const success = ({ statusCode, data }) => {
        console.log('Export success:', statusCode, data);
        downloadBlob(data, 'export.zip');
        //this.loading = false;
      }

      const error = ({ statusCode, data }) => {
        console.log('Export error:', statusCode, data);
        alert(error2text(data));
        //this.loading = false;
      }

      http.get({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files',
        blob: true,
        queryParams: [
          {
            export: 'zip',
            tagId: this.selectedTags.map(t => t.id),
            allTags: this.allTags
          }
        ]
      }).then(success, error);
    },

    subscribe() {
      //console.log("Subscribing", this.context, this.contextId);

      const topic = "/" + this.context + "/cloud/" + this.contextId;

      notifier.subscribe(topic,
          (e) => this.onFileEvent(e),
          (s) => this.storeSubscription(s)
      );

      notifier.subscribePrivate(
          (e) => this.onFileEvent(e),
          (s) => this.storeSubscription(s),
          topic
      );
    },

    storeSubscription(s) {
      if (!this.subscriptions) {
        this.subscriptions = [];
      }
      this.subscriptions.push(s);
    },

    unsubscribe() {
      if (this.subscriptions) {
        console.log("Unsubscribing", this.subscriptions);
        for (let s of this.subscriptions) {
          s.unsubscribe();
        }
        this.subscriptions = undefined;
      }
    },

    onFileEvent(data) {
      console.log('Handling file event (ws): ', data);
      if (data.type === 'upload') {
        this.onFileUploaded(data.file);
      } else if (data.type === 'update') {
        this.onFileUpdated(data.file);
      } else if (data.type === 'delete') {
        this.onFileDeleted(data.file);
      }
    },

    onFileUploaded(file) {
      console.log('File uploaded: ', file);
      this.files.push(file);

      this.pendingFiles = this.pendingFiles.filter(f =>
        f.name != file.name && f.size != file.size);

      this.$emit('file', file);
      beep();
    },

    onFileUpdated(file) {
      console.log('File updated: ', file);
      const index = findIndex(this.files, f => f.storageName === file.storageName);
      if (index >= 0) {
        const files = [...this.files];
        files[index] = file;
        this.files = files;
      } /*else {
        const files = [ ...this.files, file ];
        this.files = files;
      }*/
      if (this.selected && this.selected.storageName === file.storageName) {
        this.selected = file;
      }
    },

    onFileDeleted(file) {
      console.log('File deleted: ', file);
      const files = this.files.filter(f => f.storageName !== file.storageName);
      this.files = files;
    },

    setProgress(file, loaded, total) {
      this.$refs.fileTable.setProgress(file, loaded, total);
    },

    setFileError(file, error) {
      this.$refs.fileTable.setError(file, error);
    },

    upload(files) {
      const promises = [];
      const uploaded = {};

      for (let f of files) {
        const progress = (loaded, total) => {
          this.setProgress(f, loaded, total);
        }

        const success = ({ statusCode, data }) => {
          this.setProgress(f, f.size, f.size);
          uploaded[f.id] = data;
          return Promise.resolve(true);
        }

        const error = ({ statusCode, data }) => {
          this.setFileError(f, data);
          return Promise.reject(false);
        }

        const tags = f.tags || [];

        this.loading = true;
        const prom = http.upload({
          url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files',
          data: f,
          headers: {
            'file.tags': JSON.stringify(tags.map(t => t.id))
          },
          progress
        }).then(success, error);

        promises.push(prom);
      }

      const completed = () => {
        this.loading = false;
      };

      Promise.all(promises).then(completed, completed);
    },

    download(file) {
      const filename = file.name;

      const success = ({ statusCode, data }) => {
        console.log('Download success:', statusCode, data);
        downloadBlob(data, filename);
      }

      const error = ({ statusCode, data }) => {
        console.log('Download error:', statusCode, data);
        alert(error2text(data));
      }

      http.get({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files/' + file.storageName,
        blob: true
      }).then(success, error);

      return false;
    },

    renameFile(file) {
      const oldName =file.name;
      let newName = prompt("Rinomina file:", oldName);
      if (newName) {
        newName = newName.trim();
        if (newName) {
          this.updateFile({ ...file, name: newName });
        }
      }
    },

    updateTags(file, tags) {
      console.log('Updating tags', file, tags);

      const oldTags = file.tags.map(t => t.tag);
      const newTags = tags.map(o => ({ id: o.value }));

      if (!this.equalTags(oldTags, newTags)) {
        this.updateFile({
          ...file,
          tags: file.tags.filter(t => tags.find(x => x.value === t.tag.id))
        });
      }
    },

    updateFile(file) {
      console.log('Updating file', file);

      const success = ({ statusCode, data }) => {
        console.log('File correctly updated:', statusCode, data);
        //this.$refs.tagsModal.hide();
      }

      const error = ({ statusCode, data }) => {
        console.log('Error updating file:', statusCode, data);
        alert(error2text(data));
      }

      http.put({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files/' + file.storageName,
        data: file,
      }).then(success, error);
    },

    removeFile(file) {
      if (!confirm('Sei sicuro di voler eliminare il file?\nL\'operazione non è reversibile.')) {
        return false;
      }

      const success = ({ statusCode, data }) => {
        console.log('File correctly deleted:', statusCode, data);
        //this.$refs.tagsModal.hide();
      }

      const error = ({ statusCode, data }) => {
        console.log('Error deleting file:', statusCode, data);
        alert(error2text(data));
      }

      http.delete({
        url: env.baseUrl + '/' + this.context + '/' + this.contextId + '/files/' + file.storageName
      }).then(success, error);
    },

    addTag(file, index) {
      this.selected = file;
      this.$refs.tagsModal.show();
    },

    addTagToPendingFile(file, index) {
      this.selectedPendingFileIndex = index;
      this.$refs.pendingFilesTagsModal.show();
    },

    getTags(file) {
      return file.tags.map(t => this.mapTag(t.tag));
    },

    filterTags(selected) {
      //console.log('selected', selected);
      return tag => {
        return !selected.tags.find(t => {
          //console.log('tag', tag.id, t.tag.id);
          return t.tag.id === tag.id
        });
      };
    },

    mapTag(tag) {
      //console.log('map tag', tag);
      return {
        deletable: true,
        text: tag.label,
        value: tag.id,
        tooltip: helpForWorkgroup(tag.workgroup),
        variant: variantForWorkgroup(tag.workgroup)
      };
    },

    tagsSelected(tags) {
      console.log('tagsSelected', this.selected.tags.map(t => t.tag), tags)
      if (!this.equalTags(this.selected.tags.map(t => t.tag), tags)) {
        console.log('Updating tags');

        this.updateFile({
          ...this.selected,
          tags: tags.map(t => ({ tag: t }))
        });
      }
    },

    equalTags(list1, list2) {
      if (list1 == null) {
        list1 = [];
      }

      if (list2 == null) {
        list2 = [];
      }

      const ids1 = sortBy(list1.map(t => t.id));
      const ids2 = sortBy(list2.map(t => t.id));

      return isEqual(ids1, ids2);
    },

    pendingFilesTagsSelected(tags) {
      const index = this.selectedPendingFileIndex;
      const file = this.pendingFiles[index];
      this.updatePendingFileTags(file, index, tags);
    },

    updatePendingFileTags(file, index, tags) {
      if (!this.equalTags(file.tags, tags)) {
        console.log('Update pending file tags');
        const pendingFiles = [ ...this.pendingFiles ];
        const newFile = cloneFile(file);
        newFile.tags = tags;
        pendingFiles[index] = newFile;
        this.pendingFiles = pendingFiles;
      }
    },
  }
};
</script>
